export default "__VITE_ASSET__D7_SCkT5__"